import React from 'react';

import { findMorphOrigin } from './findMorphOrigin';
// styles and images
import styles from './Graphics.module.css';

/*****************************************
 * * Create SVG Content
 *****************************************/
export function createContent4() {
  let pathRefs = [];
  let content = [];

  // content.push(
  //   <rect key='background' className={styles.st0} width='800' height='400' />
  // );

  content.push(
    <path
      key='square2'
      className={`${styles.filled} ${styles.shape}`}
      d='M250,50H550V350H250V50z'
      ref={ref => pathRefs.push(ref)}
    />
  );

  content.push(
    <path
      key='square-shape2'
      className={`${styles.shape}`}
      // d='M300,100H500V300H300V100z'
      d='M250,50H550V350H250V50z'
    />
  );

  content.push(
    <path
      key='triangle'
      className={`${styles.triabgle} ${styles.shape}`}
      // d='M300,100H500L300,300H300V100z'
      d='M350,150H450V250H350V150z'
      ref={ref => pathRefs.push(ref)}
    />
  );

  return {
    content,
    pathRefs,
  };
}

/*****************************************
 * * Create Animation
 *****************************************/
export function createAnim4(anim, pathRefs, speed) {
  anim.clear();
  findMorphOrigin(anim, pathRefs[0], pathRefs[1], speed, {
    showLines: true,
    paused: false,
  });
}
